var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteConfirmationModal',{attrs:{"isLoading":_vm.isLoading,"title":_vm.$t('teams.delete_title'),"text":_vm.$t('teams.delete_confirmation'),"show":_vm.show},on:{"cancel":function($event){return _vm.$emit('cancel')},"delete":_vm.deleteTeam}})
}
var staticRenderFns = []

export { render, staticRenderFns }